import { ElementType } from 'react'

import { LevelFiveIcon } from '../../assets/LevelFive.icon'
import { LevelFourIcon } from '../../assets/LevelFour.icon'
import { LevelOneIcon } from '../../assets/LevelOne.icon'
import { LevelSixIcon } from '../../assets/LevelSix.icon'
import { LevelThreeIcon } from '../../assets/LevelThree.icon'
import { LevelTwoIcon } from '../../assets/LevelTwo.icon'

export const iconByLevel: Record<number, ElementType> = {
  1: LevelOneIcon,
  2: LevelTwoIcon,
  3: LevelThreeIcon,
  4: LevelFourIcon,
  5: LevelFiveIcon,
  6: LevelSixIcon,
}
